import { useState, useEffect } from "react";
import CollaborationStore from "@/store/collaboration.store";
import LoginStore from "@/store/login.store";
import Dialog from "@/component/Dialog";
import TranslateIcon from "@/assets/common/ic_translate.svg";
import SrcContent from "./SrcContent";
import { useCollaborationSocket } from "@/hooks/useCollaborationSocket";
import { useWebSocketReconnect } from "@/hooks/useWebSocketState";
import LogoHeader from "../LogoHeader";
import TitleHeader from "../TitleHeader";
import { translationOptionList } from "@/constants/translate";
import BottomActionSheet from "@/component/BottomActionSheet";
import WebSocketError from "./WebScoketError";
import { IS_PRIVATE } from "@/config";

export default function MobileCollaboration() {
  const showExitDialog = CollaborationStore((state) => state.showExitDialog);
  const setShowExitDialog = CollaborationStore(
    (state) => state.setShowExitDialog
  );
  const translationOption = CollaborationStore(
    (state) => state.translationOption
  );
  const setTranslationOption = CollaborationStore(
    (state) => state.setTranslationOption
  );
  const isVisitor = LoginStore((state) => state.isVisitor);
  const [visible, setVisible] = useState(false);

  const {
    streamId,
    showJumpSummaryDialog,
    setShowJumpSummaryDialog,
    setModalCancel,
    handleJumpSummary,
    navigate,
  } = useCollaborationSocket();

  const { readyState, handleReconnect } =
    useWebSocketReconnect(streamId);

  // 访客模式下的跳转处理
  useEffect(() => {
    if (isVisitor && showJumpSummaryDialog) {
      navigate('/meetingEnd', { replace: true });
    }
  }, [isVisitor, showJumpSummaryDialog, navigate]);

  const handleExit = () => {
    navigate("/home");
  };

  const getButtonText = () => {
    const selectedOptionData = translationOptionList.find(
      (option) => option.id === translationOption
    );
    return selectedOptionData ? selectedOptionData.value : "显示选项";
  };

  if (readyState === 3) {
    return <WebSocketError onRetry={handleReconnect} />;
  }

  return (
    <div className="h-full flex flex-col bg-#F2F3F5/88 overflow-hidden">
      {/* 移动端顶部导航栏 */}
      <div className="flex items-center justify-between h-14">
        {isVisitor && <LogoHeader />}
        {!isVisitor && (
          <div className="ml-1">
            <TitleHeader
              title=""
              backPop={{
                popTitle:
                  "返回首页后，将无法回到当前实时录制，需重新扫码再次进入",
                confirmText: "返回",
                cancelText: "暂不返回",
              }}
            />
          </div>
        )}
        {
          // TODO: 私有化环境下，不显示切换原文/译文按钮
          !IS_PRIVATE && (
            <div
              onClick={() => setVisible(true)}
              className={`flex items-center h-8 text-mx-secondary no_drag cursor-pointer bg-#FFFFFF rd-2 mr-4 px-2.5 py-1`}
              style={{ width: "auto", minWidth: "fit-content" }}
            >
              <img src={TranslateIcon} className="w-4.5 h-4.5 mr-1" />
              <span className="text-3.5 truncate">{getButtonText()}</span>
            </div>

          )
        }
      </div>

      {/* 移动端主内容区 */}
      <div className="flex-1 overflow-hidden my-2">
        <SrcContent />
      </div>

      <BottomActionSheet
        visible={visible}
        setVisible={setVisible}
        title="选择显示语言"
      >
        <div className="px-6 pb-6">
          {translationOptionList.map((option) => (
            <div
              key={option.id}
              onClick={() => {
                setTranslationOption(option.id);
                setVisible(false);
              }}
              className={`flex items-center justify-between h-12.5 cursor-pointer text-#191D26`}
            >
              <span className="text-4">{option.value}</span>
              <div
                className={`w-4 h-4 rounded-full border-1 border-solid flex items-center justify-center ${translationOption === option.id
                  ? " border-#4981F2"
                  : "border-#DBDEE4"
                  }`}
              >
                {translationOption === option.id && (
                  <div className="w-2 h-2 bg-#4981F2 rounded-full"></div>
                )}
              </div>
            </div>
          ))}
        </div>
      </BottomActionSheet>

      {/* 对话框组件 */}
      <Dialog
        isOpen={showExitDialog}
        onCancel={() => setShowExitDialog(false)}
        onConfirm={handleExit}
        title=""
        content="确定退出吗？大屏会议结束后，记录将自动保存至最近列表"
        confirmText="退出"
      />
      {!isVisitor && (
        <Dialog
          isOpen={showJumpSummaryDialog}
          onCancel={() => {
            setShowJumpSummaryDialog(false);
            setModalCancel(true);
          }}
          onConfirm={handleJumpSummary}
          confirmType="primary"
          confirmText="查看"
          confirmTimeout={10 * 1000}
          title="大屏会议已结束"
          content="正在为你跳转智能总结详情"
        />
      )}
    </div>
  );
}
